type Props = {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
  tone?: 'dark' | 'light';
};

export default function SectionHeader({ eyebrow, title, desc, align = 'left', tone = 'dark' }: Props) {
  const titleColor = tone === 'light' ? 'text-background-50' : 'text-foreground-950';
  const descColor = tone === 'light' ? 'text-background-50/70' : 'text-foreground-600';
  const eyebrowColor = tone === 'light' ? 'text-accent-200' : 'text-primary-600';

  return (
    <div className={align === 'center' ? 'mx-auto max-w-2xl text-center' : 'max-w-2xl'}>
      <p
        className={`inline-flex items-center gap-2 text-xs font-bold tracking-[0.2em] uppercase md:text-sm ${eyebrowColor}`}
      >
        <i className="ri-arrow-right-up-line" />
        {eyebrow}
      </p>
      <h2 className={`mt-3 font-serif text-2xl font-black md:text-4xl ${titleColor}`}>{title}</h2>
      {desc && <p className={`mt-4 text-sm leading-relaxed md:text-base ${descColor}`}>{desc}</p>}
    </div>
  );
}